<script>
	import Gallery from '../Stores/Gallery';
	import Layout from '../Stores/Layout';

	let xr_support = false;
	let xr_active = true;

	function reset() {
		xr_active = false;
		const clone = $Gallery.items;
		for (let item of clone) item.active = false;
		$Gallery.items = clone;
	}

	function paint() {
		Layout.info();
	}

	function xr() {
		reset();
		xr_active = true;
		window.renderer.autoRotation(false);
		document.getElementById('VRButton').click();
	}

	function perspective(item) {
		reset();
		item.active = true;
		window.renderer.autoRotation(false);
		window.renderer.perspective(item.perspective);
	}

	function rendererLoaded(event) {
		xr_support = window.renderer.xrSupport();
	}

	window.addEventListener('renderer_loaded', rendererLoaded, false);
</script>

<style>
	div.zes-gallery {
		display: grid;
    	grid-template-columns: repeat(auto-fit, minmax(1em, 1fr));
    	gap: 0 .75em;
		padding: 0 2em 2em 2em;
		z-index: 30;
	}

	div.zes-gallery > div {
		padding: .25em;
		border-radius: .3em;
		border: 1px solid hsl(0deg 0% 100%);
		box-shadow: .1em .1em 1.25em hsl(0deg 0% 0% / .1);
		background: hsl(0deg 0% 100%);
		cursor: pointer;
	}

	div.zes-gallery > div.zes-active {
		box-shadow: 0 0 .5em 0 var(--zes-1-3);
		border-color: var(--zes-1-3);
	}

	div.zes-gallery > div > div {
		width: 100%;
    	position: relative;
		border-radius: .2em;
		background-color: #B3DEF4;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	div.zes-gallery > div > div::before {
		content: '';
		display: block;
		padding-top: 65%;
	}

	div.zes-gallery > div > div.zes-icon {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFF;
		background-color: var(--zes-1-3);
	}

	div.zes-gallery > div > div.zes-icon i {
		font-size: 2em;
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-gallery {
			font-size: .5em;
		}

		div.zes-gallery > div > div {
			max-width: 9em;
			height: 6em;
		}
	}
</style>

<div class="zes-gallery">
	{#if xr_support}
		<div class:zes-active="{xr_active}" on:click="{event => xr()}">
			<div class="zes-icon">
				<i class="fa-duotone fa-head-side-goggles"></i>
			</div>
		</div>
	{/if}
	{#each $Gallery.items as item}
		<div class:zes-active="{item.active}" on:click="{event => perspective(item)}">
			<div style="background-image: url('{item.image}')"></div>
		</div>
	{/each}
</div>